const ArrowIcon = ({ color = "#5B36F2" }) => {
    return (
        <svg viewBox="0 0 12 12" fill={color} xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6666 5.33329H2.93329L6.46663 1.79996C6.73329 1.53329 6.73329 1.13329 6.46663 0.866626C6.19996 0.599959 5.79996 0.599959 5.53329 0.866626L0.866626 5.53329C0.799959 5.59996 0.733293 5.66663 0.733293 5.73329C0.666626 5.79996 0.666626 5.93329 0.666626 5.99996C0.666626 6.06663 0.666626 6.19996 0.733293 6.26663C0.799959 6.33329 0.799959 6.39996 0.866626 6.46663L5.53329 11.1333C5.66663 11.2666 5.86663 11.3333 5.99996 11.3333C6.13329 11.3333 6.33329 11.2666 6.46663 11.1333C6.73329 10.8666 6.73329 10.4666 6.46663 10.2L2.93329 6.66663H10.6666C11.0666 6.66663 11.3333 6.39996 11.3333 5.99996C11.3333 5.59996 11.0666 5.33329 10.6666 5.33329Z"/>
        </svg>

    );
}

export default ArrowIcon;